import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';

const MissingPrerequisiteStepActionPickerButton = ({ resource, onClick }) => {
  return resource.withRelationship(fr.relationships.settingsSectionSecurity.name,
    (rel) => <FDPrimaryActionButton label={rel.meta('prompt')} onClick={onClick} />,
    () => null);
};

MissingPrerequisiteStepActionPickerButton.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MissingPrerequisiteStepActionPickerButton;
